<template >
    <div>
      <div @click.stop="toggleExpand" class="p-n fs-15 fw-600 sub-header desk-c-pointer" :class="{'geoff-border-bottom' : expanded}">
        <div>Payable Odds</div>
        <div 
          
          class="mx-2 collapse-btn-wr d-flex align-items-center"
        >
          <svg  class="collapse-btn" :class="{'reverse':expanded}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00005 5.72376L10.862 0.861827L11.8048 1.80464L6.00005 7.60937L0.195312 1.80464L1.13812 0.861828L6.00005 5.72376Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <collapse-transition :duration="200">
        <div class="p-n" v-if="expanded">
          
          <table class="odds-info-tbl">
            <tbody>
              <tr>
                <td></td>
                <td v-for="(col, idx) in model.columns" 
                    :key="idx">{{ col }}</td>
              </tr>
              <tr v-for="(row, idxRow) in model.data" :key="idxRow">
                <td>{{ row.label }}</td>
                <td v-for="(cell, idxCell) in row.values" 
                  :key="idxCell">{{ glb.formatPrice(cell) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </collapse-transition> 

    </div>
</template>

<script>
  import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
  
  export default {
    name: "LottoOddsInfo",
    components: {
      CollapseTransition
    },
    props: {
      model: {
        type: Object
        /* example*
        {
          cols:['6 Drawn', '7 Drawn'],
          selections:[
            {
              label: 'Singles',
              values: ['13/2', '11/2']
            },
            {
              label: 'Doubles',
              values: ['66/1', '44/1']
            },
            {
              label: 'Trebles',
              values: ['700/1', '440/1']
            },
          ],
        }
        */
      }
    },
    data: () => {
      return {
        results: [],
        intervalLoad: null,
        expanded: false,
      }
    },
    methods: {
      toggleExpand() {
        this.expanded = !this.expanded
      },
    }
  }
</script>

<style scoped lang="scss">
  .res-card {
    width: auto;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;
  }

  .sub-header {
    font-size: 0.9375rem;
    font-weight: 600;
    justify-content: space-between;
  }

  .collapse-btn-wr {
    width: 12px;
    .collapse-btn {
      transition: transform 0.2s;

      &.reverse{
        transform: rotate(180deg);
      }
    }
  }

  .odds-info-tbl {
    width: 100%;
    text-align: center;
    tr {
      &:first-child {
        font-weight: 700;
      }
      td:first-child {
        font-weight: 700;
      }
    }
    
  }


</style>